export default {
    bar: { 
        display: 'flex',
        flexDirection: 'row',
        height: '60px',
        backgroundColor: '#ededed',
        marginTop: 30
    }, 

    container: { 
        display: 'flex',
        flexDirection: 'row',
        width: '80%',
        height: '100%',
        margin: '0 auto',
        backgroundColor: '#ededed'
    },

    brand: { 
        maxHeight: '100%',
        padding: '10px'
    },

    item: { 
        marginTop: '10px',
        padding: '12px', 
        fontSize: '16px',
        fontWeight: 'bold'
    }, 

    img: { 
        maxHeight: '100%',
    },

    ul: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        listStyleType: 'none'
    },
}